import React from "react";

const HotspotContext = React.createContext({});
export const HotspotProvider = HotspotContext.Provider

export default HotspotContext